<template>
	<div class="main">
		<div class="zyzzc-top">
			<div class="left" @click="toZc">
				<img src="../../../static/zyzzc_zc.png" alt="">
			</div>
			<div class="right">
				<p>
					第一条为加强与广大观众的联系、交流，扩大博物馆的文化普及程度，提升义务咨询和讲解服务的力度，中国人民解放军海军事博物馆，吸收热爱博物馆事业，具有奉献精神，自愿利用个人的时间，无偿为博物馆服务的人士为“中国人民解放军海军博物馆志愿者”
				</p>
				<p>
					第二条中国人民解放军海军博物馆志愿者的身份由中国人民解放军海军博物馆志愿者认定。志愿者须遵守军博的各项规章制度，自觉服从军博的管理。
				</p>
				<p>
					第三条志愿者以志愿服务为宗旨，以传播军事历史、军事文化、军事科技、军事艺术知识为目标，倡导社会爱心，发扬团结互助，以服务社会大众为己任。
					<span style="color: #1059BF; cursor: pointer;" @click="toZc">更多》</span>
				</p>
			</div>
		</div>
		<div class="zyzzc-list">
			<div class="zyzzc-block">
				<div class="zyzzc-box" v-for="(item, index) in dataList" :key="index" @click="toDetails(item.id)">
					<img :src="$imgUrl + item.listImgPc" alt="">
					<div class="zyzzc-box-title">
						{{item.shortTitle}}
					</div>
				</div>
			</div>
			<page :pageObj="params" @getDataList="getData"></page>
		</div>
	</div>
</template>

<script>
	import Page from '@/components/Page.vue'
	export default {
		name: '',
		components: {
			Page
		},
		data () {
			return {
				params: {
					current: 1,
					size: 6,
					channelId: this.$store.state.channelId,
					releaseTerrace: "releasePc"
				},
				dataList: []
			}
		},
		mounted() {
			let that = this
			that.$store.state.showTopImage = true
			that.$store.state.topImage = '../../static/top_banner_4.png'
		},
		methods: {
			getData(dataList) {
				this.dataList = dataList
			},
			toDetails(hd_id) {
				this.$router.push({
					path: '/zyzzc_details',
					query: {
						hd_id: hd_id
					}
				})
			},
			toZc() {
				this.$router.push({
					path: '/zyzzc_zc'
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	.main {
		width: 80%;
		margin: 18px 10% 80px;
		.zyzzc-top {
			width: 100%;
			display: flex;
			justify-content: space-between;
			padding-bottom: 30px;
			border-bottom: 3px solid #1059BF;
			font-size: 18px;
			.left {
				width: 15%;
				img {
					width: 100%;
					height: 100%;
					cursor: pointer;
				}
			}
			.right {
				width: 80%;
				display: flex;
				text-align: left;
				flex-direction: column;
				justify-content: space-around;
			}
		}
		.zyzzc-list {
			margin-top: 20px;
			width: 100%;
			.zyzzc-block {
				width: 100%;
				display: flex;
				flex-wrap: wrap;
				.zyzzc-box {
					width: 32%;
					margin: 10px 0.66%;
					display: flex;
					flex-direction: column;
					img {
						width: 100%;
						cursor: pointer;
					}
					.zyzzc-box-title {
						width: 100%;
						height: 40px;
						line-height: 40px;
						color: #FFFFFF;
						font-size: 16px;
						text-align: center;
						background-image: url(../../../static/zyzzc_bg.png);
						background-size: 100% 100%;
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/teaching_activities/zyzzc.vue